import { Model, transforms, Validator } from 'model-core';

import ReportingHistoryStatus from './ReportingHistoryStatus';
import { ReportingHistorySchema } from './schema';

/**
 * Representation of a reporting history
 */
export default class ReportingHistory extends Model {
  static transforms = {
    date: transforms.makeMomentTransform(),
    status: ReportingHistoryStatus.instantiate,
  };

  static validator = new Validator(ReportingHistorySchema);
}
